const contextActionType = {
    SET_STYLES_OPEN: "SET_STYLES_OPEN",
    GET_STYLES_OPEN: "GET_STYLES_OPEN",
    SET_ACTIVE_PLAYER: "SET_ACTIVE_PLAYER",
    GET_ACTIVE_PLAYER: "GET_ACTIVE_PLAYER"
};

export default contextActionType; 